var _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBascket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#7ebc0a",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4h10l1 2h4v2h-2l-1.5 9a2 2 0 0 1-2 1.7H7.5a2 2 0 0 1-2-1.7L4 8H2V6h4l1-2zm0.8 2l-.6 2h9.6l-.6-2H7.8zM6 8l1.5 9h9L18 8H6z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 8,
    x2: 8,
    y2: 17,
    stroke: "#7ebc0a",
    strokeWidth: 0.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 8,
    x2: 10,
    y2: 17,
    stroke: "#7ebc0a",
    strokeWidth: 0.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 17,
    stroke: "#7ebc0a",
    strokeWidth: 0.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 8,
    x2: 14,
    y2: 17,
    stroke: "#7ebc0a",
    strokeWidth: 0.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 8,
    x2: 16,
    y2: 17,
    stroke: "#7ebc0a",
    strokeWidth: 0.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 11,
    x2: 18.5,
    y2: 11,
    stroke: "#7ebc0a",
    strokeWidth: 0.8
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 13,
    x2: 18.5,
    y2: 13,
    stroke: "#7ebc0a",
    strokeWidth: 0.8
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 15,
    x2: 18.5,
    y2: 15,
    stroke: "#7ebc0a",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBascket);
export default __webpack_public_path__ + "static/media/bascket.184f2640f987614bdefda35b7b8c27d3.svg";
export { ForwardRef as ReactComponent };